import { GET_UNREAD } from '../../actiontypes'

export const UnreadmsgFetchReducer = (unreadmsg) => {
    return (dispatch) => {
            dispatch({ type: GET_UNREAD, payload: unreadmsg});
    }      
};